
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useRealtimeClients } from "@/hooks/use-realtime-clients";

export function ClientsSummary() {
  const { clients, isLoading } = useRealtimeClients();

  if (isLoading) {
    return <div className="flex flex-col items-center justify-center h-32 w-full">
        <Loader2 className="h-6 w-6 text-primary animate-spin" />
        <p className="text-sm text-muted-foreground mt-2">Carregando clientes...</p>
      </div>;
  }

  if (clients.length === 0) {
    return <div className="flex flex-col items-center justify-center h-32 w-full">
        <p className="text-sm text-muted-foreground">Nenhum cliente registrado</p>
        <Link to="/clients">
          <Button variant="outline" size="sm" className="mt-2">
            Adicionar cliente
          </Button>
        </Link>
      </div>;
  }

  // Mostrar apenas os primeiros 5 clientes
  const displayClients = clients.slice(0, 5);
  return <div className="space-y-3">
      {displayClients.map(client => <Link key={client.id} to={`/clients/${client.id}`}>
          <div className="flex items-center justify-between rounded-md border p-3 hover:bg-muted/50 transition-colors cursor-pointer py-[14px] my-[8px]">
            <div className="flex items-center gap-3">
              <Avatar className="h-8 w-8">
                <AvatarFallback className="bg-primary text-primary-foreground">
                  {client.name?.charAt(0) || "C"}
                </AvatarFallback>
              </Avatar>
              <div>
                <p className="text-sm font-medium">{client.name}</p>
                {client.contact_name && <p className="text-xs text-muted-foreground">{client.contact_name}</p>}
              </div>
            </div>
            <div className="flex gap-1 items-center text-xs bg-primary/10 text-primary px-2 py-1 rounded-full">
              0 tarefas
            </div>
          </div>
        </Link>)}
      
      {clients.length > 5 && <Link to="/clients" className="block">
          <Button variant="outline" size="sm" className="w-full">
            Ver todos os {clients.length} clientes
          </Button>
        </Link>}
    </div>;
}
